import React, { useContext } from "react";
import { Button, Caption, Surface, useTheme } from "react-native-paper";
import { Block } from "@block";
import { useDispatch, useSelector } from "react-redux";
import { spacing } from "@styles/spacing";
import { useTranslation } from "react-i18next";
import { QueueSpacing, StackSpacing } from "@components/spacing";
import { SideMenuContext } from "../../side-menu/side-menu";
import CustomQRCreator from "../../custom-qr-creator/custom-qr-creator";
import GlobalViewShot, { GlobalViewShotRef } from "../../global-view-shot/global-viewshot.web";
// import { useNavigation } from "@react-navigation/core";
import ScreenNameType from "app/shared/constant/nav-screen.type";
import CustomQRCreatorUtils from "../../custom-qr-creator/custom-qr-creator-utils";
import { navigationRef } from "app/shared/util/root-navigator";
import { showModal } from "app/modules/modal-management/reducer/action";
import { mapAccountPayments } from "app/shared/util/common";
import { ACCOUNT } from "app/shared/services/services-model.type";
import { getListAccountSelector } from "app/modules/account-management/reducer/selectors";
import { pushAppFlyer } from "app/shared/util/app-flyer";

const MyQrCode = () => {
  const { colors, fonts } = useTheme();
  const { t } = useTranslation();
  // const { navigate } = useNavigation();
  const listAccount = useSelector(getListAccountSelector);
  const { hideMenu } = useContext(SideMenuContext);
  const [account, setAccount] = React.useState<ACCOUNT>({});
  const globalViewShotRef = React.useRef<GlobalViewShotRef>(null);
  const dispatchStore = useDispatch();

  const handlerParamsAppFlyer = (value: boolean) => {
    console.log("handlerParamsAppFlyer");
    const param = {
      success: value,
      failure: !value,
    };
    return {
      eventName: "af_save_my_qr",
      params: {
        af_channel: "ib_rb",
        af_view_my_qr: JSON.stringify(param),
      },
    };
  };

  const libraryQR = () => {
    hideMenu();
    navigationRef?.current?.navigate(ScreenNameType.QR_LIBRARY);
  };

  const getAccountDefault = React.useCallback(() => {
    let accountDefault: ACCOUNT = {};
    if (listAccount?.ACCOUNT.length) {
      const list: ACCOUNT[] = mapAccountPayments(listAccount.ACCOUNT);
      if (list.length) accountDefault = list[0];
    }
    return accountDefault;
  }, [listAccount?.ACCOUNT]);

  const printQRtoPDF = () => {
    hideMenu();
    let isSuccess = false;
    if (!account) {
      dispatchStore(
        showModal({
          modalType: "alert",
          modalProps: {
            message: t("COMMON_KHONG_CO_DU_LIEU"),
            open: true,
          },
        }),
      );
    } else {
      isSuccess = true;
      globalViewShotRef.current?.takeViewShot();
    }
    const { eventName, params } = handlerParamsAppFlyer(isSuccess);
    pushAppFlyer(eventName, params);
  };

  React.useEffect(() => {
    if (listAccount?.ACCOUNT.length) {
      setAccount(getAccountDefault());
    }
  }, [getAccountDefault, listAccount?.ACCOUNT]);

  const QRDownload = (
    <div style={{ overflow: "hidden", height: 0, width: 0 }}>
      <GlobalViewShot watermark={false} ref={globalViewShotRef}>
        <CustomQRCreator
          value={{
            valueQR: CustomQRCreatorUtils.createStringForQR(account),
            accountName: account?.ACCOUNTNAME,
            accountNumber: account?.ACCOUNTNO,
          }}
          mode="fullsize"
        />
      </GlobalViewShot>
    </div>
  );

  return (
    <>
      <Surface style={{ borderRadius: 20 }}>
        <Block row flex={1} pv={spacing.medium} ph={spacing.huge}>
          <Block>
            <CustomQRCreator value={{ valueQR: CustomQRCreatorUtils.createStringForQR(account) }} />
          </Block>
          <QueueSpacing size="medium" />
          <Block flex={1}>
            <Block middle flex={1}>
              <Button
                onPress={printQRtoPDF}
                uppercase={false}
                color={colors.accent}
                mode="contained"
                style={{ borderRadius: 24, height: 36 }}>
                <Caption style={{ ...fonts.medium, color: colors.surface, fontSize: 10 }}>{t("ACC_TAI_VE")}</Caption>
              </Button>
            </Block>
            <Block middle flex={1}>
              <Button uppercase={false} color={colors.accent} mode="contained" style={{ borderRadius: 24 }} onPress={libraryQR}>
                <Caption style={{ ...fonts.medium, color: colors.surface, fontSize: 10 }}>{t("COMMON_THU_VIEN_QR")}</Caption>
              </Button>
            </Block>
          </Block>
          <StackSpacing size="small" />
        </Block>
      </Surface>
      {QRDownload}
    </>
  );
};

export default MyQrCode;
